import { render, staticRenderFns } from "./OrderServiceQuotationAnswerForms.vue?vue&type=template&id=01636410&scoped=true&"
import script from "./OrderServiceQuotationAnswerForms.vue?vue&type=script&lang=js&"
export * from "./OrderServiceQuotationAnswerForms.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceQuotationAnswerForms.vue?vue&type=style&index=0&id=01636410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01636410",
  null
  
)

export default component.exports